export default __webpack_public_path__ + "static/char-v-58-zh-Hant-f79d394c1e3c69179be0a5f9cde04c1e.mp4";